import Vue from 'vue'
import dialogPlugin from '@tencent/vft-vue-plugins/src/dialog'
import reportPlugin from '@tencent/vft-report-sdk'
import ImgPlugin from '@tencent/vft-vue-plugins/src/img/v-img'
import {
  PicGeneratorPlugin
} from '@tencent/vft-image-plugins'
import store from '../store'
import LoginPlugin from '@tencent/vft-vue-plugins/src/login'
import ScreenOrientation from '@tencent/vft-ui/src/ScreenOrientation'
import Avatar from '@tencent/vft-ui/src/Avatar'
import reportData from './reportData'
import ScrollLocker from '../util/ScrollLocker'

Vue.use(ScreenOrientation)
Vue.use(LoginPlugin)
Vue.use(dialogPlugin)
Vue.use(ImgPlugin)
Vue.use(PicGeneratorPlugin)
Vue.use(Avatar)

Vue.use(reportPlugin, {
  reportData,
  reporterArr: [new reportPlugin.BossReport({
    pvBoss: {
      bossId: 5380,
      pwd: 895678138
    },
    eventBoss: {
      bossId: 5380,
      pwd: 895678138
    },
    presetParam: function () {
      const param = reportPlugin.BossReport.getPresetParam()
      return Object.assign(param, {
        f_vip: store.state.payVip ? store.state.payVip.vip : -1,
        f_level: store.state.payVip ? store.state.payVip.level : 0
      }) // 上报基础参数中需要包含会员身份信息，所以上报需要在获取会员身份信息后再启动
    }
  })]
})

Vue.directive('lock-scroll', {
  bind (el, binding) {
    if (binding.modifiers.skip) {
      el.dataset.skipLocker = true
    }
  },
  inserted (el, binding) {
    if (binding.modifiers.skip) {
      return
    }
    const isLock = binding.hasOwnProperty("value") ? !!binding.value : true
    if (isLock) {
      ScrollLocker.lock(el)
    }
  },
  componentUpdated (el, binding) {
    if (binding.modifiers.skip) {
      return
    }

    const isLock = binding.hasOwnProperty("value") ? !!binding.value : true
    if (isLock) {
      ScrollLocker.lock(el)
    } else {
      ScrollLocker.unlock(el)
    }
  },
  unbind (el, binding) {
    if (binding.modifiers.skip) {
      return
    }
    ScrollLocker.unlock(el)
  }
})

Vue.directive('to-app', {
  bind (el, binding) {
    const isGame = navigator.userAgent.toLowerCase().indexOf('msdk') >= 0
    // const isZhihu = navigator.userAgent.toLowerCase().indexOf('zhihu') >= 0
    const isWeibo = navigator.userAgent.toLowerCase().indexOf('weibo') >= 0

    el.addEventListener('click', (e) => {
      if (isGame || isWeibo) {
        Vue.prototype.alert({
          title: '提示',
          msg: '请在腾讯视频APP内，点击首页右上角【金猪挂件】参与活动'
        })

        e.stopPropagation()
        e.preventDefault()
        return false
      }
    }, true)
  }
})
